/**
 * ARTWORK ENGINE FEATURE FLAGS.
 *
 * Anything that is real but not yet proven stable in PRODUCTION sits behind a
 * flag here rather than shipping as a regression. Flags are read from the URL
 * so they can be turned on per-session without a deploy.
 *
 *   ?rhino=1     — enable the direct Rhino .3dm housing path (2.6 MB WASM
 *                  decoder). OFF by default: the production housing path is
 *                  web-optimized glTF/GLB (tools/convert-3dm-to-glb.mjs), and a
 *                  .3dm URL falls back to the parametric ring instead of pulling
 *                  a multi-megabyte decoder into a rep's session.
 *   ?ai=0        — kill switch for the optional gpt-image-1 photoreal FINISH
 *                  pass. The finish pass is ON by default: OPENAI_API_KEY is
 *                  wired on the backend and it is a real, reachable final step
 *                  for a rep. It is NOT text-to-image — it applies
 *                  metal/finish/lighting to the ALREADY-COMPOSED real
 *                  components with the locked layer masked. `?ai=0` exists only
 *                  so it can be switched off without a deploy.
 *   ?demo=1      — canned data for every source (repo-wide convention).
 */

function flag(name) {
  if (typeof window === 'undefined') return false
  return new URLSearchParams(window.location.search).get(name) === '1'
}

/** Read a flag that defaults to ON — only an explicit `?name=0` disables it. */
function flagOffSwitch(name) {
  if (typeof window === 'undefined') return true
  return new URLSearchParams(window.location.search).get(name) !== '0'
}

/** Direct .3dm loading (heavy WASM). Default OFF — glTF/GLB is the live path. */
export function rhinoEnabled() {
  return flag('rhino')
}

/**
 * The optional photoreal FINISH pass — ON by default, reachable in production.
 *
 * This is the ONLY place AI touches a build, and only as the final step ON TOP
 * of the assembled real components: metal, finish and lighting, with the locked
 * layer (SR mark, client crest, designs, keyed type) masked and protected.
 * It is never a path back to text-to-image generation — the engine still
 * assembles the piece; this only re-renders its material.
 */
export function photorealFinishEnabled() {
  return flagOffSwitch('ai')
}

export function isDemo() {
  return flag('demo')
}
